import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../Config/firebase";

const AuthContext = React.createContext({});

function AuthProvider({ children }) {
  const [logado, setLogado] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [permissoesAcesso, setPermissoesAcesso] = useState({});

  useEffect(() => {
    setPermissoesAcesso({});
    if (!usuario) return undefined;
    return onSnapshot(doc(db, "users", usuario.uid), (snapshot) => {
      const dados = snapshot.exists() ? snapshot.data() : {};
      if (dados.tipo) localStorage.setItem("tipoUsuario", String(dados.tipo).toLowerCase());
      setPermissoesAcesso(dados.ativo === false ? {} : dados.permissoesAcesso || {});
    }, () => setPermissoesAcesso({}));
  }, [usuario]);

  // 🔑 ESTADO CRÍTICO PARA EVITAR LOGOUT NO F5
  const [carregandoAuth, setCarregandoAuth] = useState(true);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUsuario(user);
        setLogado(true);
        localStorage.setItem("logado", "S");

        try {
          const usuarioSnap = await getDoc(doc(db, "users", user.uid));
          const dadosUsuario = usuarioSnap.exists() ? usuarioSnap.data() : {};
          const tipo = String(dadosUsuario.tipo || "").toLowerCase();
          const tenantId = dadosUsuario.tenantId || "";
          const planoUsuario = String(dadosUsuario.plano || "").toLowerCase();
          let adminPrincipal = tipo === "admin" && dadosUsuario.adminPrincipal === true;

          if (tipo === "admin" && tenantId) {
            const tenantSnap = await getDoc(doc(db, "tenants", tenantId));
            const adminPrincipalId = tenantSnap.exists()
              ? tenantSnap.data()?.adminPrincipalId || ""
              : "";
            if (adminPrincipalId) adminPrincipal = adminPrincipalId === user.uid;
          }

          localStorage.setItem("adminPrincipal", adminPrincipal ? "S" : "N");
          localStorage.setItem("planoUsuario", planoUsuario);
        } catch {
          localStorage.setItem("adminPrincipal", "N");
          localStorage.removeItem("planoUsuario");
        }
      } else {
        setUsuario(null);
        setLogado(false);
        localStorage.setItem("logado", "N");
        localStorage.removeItem("adminPrincipal");
        localStorage.removeItem("planoUsuario");
      }

      // 🔥 SÓ AQUI O APP PODE DECIDIR ROTAS
      setCarregandoAuth(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        logado,
        setLogado,
        usuario,
        permissoesAcesso,

        // ⚠️ MANTÉM COMPATIBILIDADE
        loading: carregandoAuth,

        // ✅ NOME CORRETO USADO NO App.jsx
        carregandoAuth
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
